<div id="dialog-header-identifier" class="dialog-header">
  <ng-content select="dialog-header, [dialog-header]"></ng-content>
</div>
<div class="dialog-content">
  <ng-content select="dialog-content, [dialog-content]"></ng-content>
</div>
<mat-divider></mat-divider>
<div class="dialog-actions">
  <ng-content select="dialog-actions, [dialog-actions]"></ng-content>
</div>
